import { render, staticRenderFns } from "./SaleRecallPlan.vue?vue&type=template&id=5edd6f96&scoped=true&"
import script from "./SaleRecallPlan.vue?vue&type=script&lang=js&"
export * from "./SaleRecallPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edd6f96",
  null
  
)

export default component.exports